import React from 'react';

import withMenuEmptyState from 'features/menu/components/with-menu-empty-state';
import RecentOrderCardList from 'features/menu/pages/recent-items-page/recent-order-card-list';
import { View } from 'react-native';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';

const MenuRecentItemsComponent = () => {
  useRumPageView('menu-recents', 'Menu Recents Items');

  return (
    <View style={{ flex: 1 }} testID="menu-recents-page">
      <RecentOrderCardList />
    </View>
  );
};

export const MenuRecentItemsPage = withMenuEmptyState(MenuRecentItemsComponent);
